import {
  ADD_PROJECT,
  GET_PROJECT,
  GET_PROJECTS,
  DELETE_PROJECT,
  UPDATE_PROJECT,
  REQUEST_ADD_PROJECT,
  REQUEST_UPDATE_PROJECT,
  REQUEST_DELETE_PROJECT,
  ERROR_XHR
} from '../mutation-types'

const state = {
  all: [],
  project: {},
  projectCreated: false,
  projectUpdated: false
}

const mutations = {
  // Project find
  [GET_PROJECTS] (state, projects) {
    state.all = projects.sort(function (a, b) {
      if (a.contact_lastname < b.contact_lastname) return -1
      if (a.contact_lastname > b.contact_lastname) return 1
      return 0
    })
    state.projectAdded = false
  },
  [GET_PROJECT] (state, project) {
    state.project = project
  },
  // Project creation
  [REQUEST_ADD_PROJECT] (state) {
    state.projectCreated = false
  },
  [ADD_PROJECT] (state, project) {
    state.all.push(project)
    state.projectCreated = project.id
  },
  // Project update
  [REQUEST_UPDATE_PROJECT] (state) {
    state.projectUpdated = false
  },
  [UPDATE_PROJECT] (state, oldProject, updatedProject) {
    state.all.$remove(oldProject)
    state.all.push(updatedProject)
    state.projectUpdated = true
  },
  [REQUEST_DELETE_PROJECT] (state, project) {
    state.projectDelete = false
  },
  // Project delete
  [DELETE_PROJECT] (state, project) {
    state.all.$remove(project)
  },
  [ERROR_XHR] (state, error) {
    console.log(state)
    console.log(error)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/projects.js